define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var lpAgent = require('web-agent-assets-js/lpAgent');

    window.lpTag = window.lpTag || {};
    lpTag.taglets = lpTag.taglets || {};

    lpTag.lpParticipantController = function (model) {

        var participantController = {applicationType: "lpParticipantController"};

        // Model Methods
        participantController.getModelParam = function (paramName) {
            return model.get(paramName);
        };
        participantController.bindModelParam = function (modelParam, func, scope, trigger) {
            model.bind(modelParam, func, scope, trigger);
        };
        participantController.unbindModelParam = function (key, callback, context) {
            model.unbind(key, callback, context);
        };

        // Decorator Methods
        participantController.getCustomVariables = function (object) {
            lpAgent.participant.getCustomVariables(object);
        };
        participantController.getVisitSessionPages = function (object) {
            lpAgent.participant.getVisitSessionPages(object);
        };
        participantController.getVisitSessionDetails = function (object) {
            return lpAgent.participant.getVisitSessionDetails(object);
        };
        participantController.getChatHistory = function (object) {
            lpAgent.participant.getChatHistory(object);
        };
        participantController.getOperatorAlerts = function (object) {
            lpAgent.participant.getOperatorAlerts(object);
        };

        function init() {
            if (lpAgent.participant) {
                // Register on chat callbacks
                for (var key in lpAgent.participant) {
                    if (lpAgent.participant.hasOwnProperty(key) && String(key).indexOf('on') === 0) {
                        switch (key) {
                            case    "onVisitSessionKey":
                                lpAgent.participant[key](handleVisitSessionKey);
                                break;
                            case    "onVisitSessionDetails":
                                lpAgent.participant[key](handleVisitorSessionDetails);
                                break;
                            case    "onCustomVariables":
                                lpAgent.participant[key](handleCustomVariables);
                                break;
                            case    "onVisitSessionPages":
                                lpAgent.participant[key](handleVisitSessionPages);
                                break;
                            case    "onChatHistory":
                                lpAgent.participant[key](handleChatHistory);
                                break;
                            case    "onOperatorAlerts":
                                lpAgent.participant[key](handleOperatorAlerts);
                                break;
                            default:
                                if (lpAgent.participant.hasOwnProperty(key)) {
                                    lpAgent.participant[key](updateModel);
                                }
                        }
                    }
                }
            } else {
                setTimeout(init, 500);
            }
        }

        function updateModel(data) {
            model.modify("participants", data);
        }

        /**
         * Write the visit session key to the model. The location is determined by the visitor ID and chat ID.
         * The location is "participants.myEngagements.{visitorId}.visitSessionKeys.{chatId}" and the value is
         * the visit session key.
         * @param data - JSON containing the visitor ID, chat ID and visit session key.
         */
        function handleVisitSessionKey(data) {
            var visitorId, chatId, visitSessionKey;
            if (data) {
                visitorId = data.visitorId;
                chatId = data.chatId;
                visitSessionKey = data.visitSessionKey;
            }
            if (visitorId && chatId && visitSessionKey) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                model.modify(participantPath + ".visitSessionKeys." + chatId, visitSessionKey);
            }
        }

        function handleVisitorSessionDetails(data) {
            var shark, visitorInfo, sessionInfo;
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorId);
            if (model.get(participantPath)) {
                model.modify(participantPath + ".participantInfo.visitSessionKey", data.visitSessionKey);
                shark = model.get(participantPath + ".participantInfo.shark");
                sessionInfo = data.sessionDetails.sessionInfo.info;
                model.modify(participantPath + ".participantInfo", lpUtils.nameValuePairToJSON(sessionInfo));

                if (!shark) {
                    visitorInfo = data.sessionDetails.visitorInfo.info;
                    model.modify(participantPath + ".participantInfo", lpUtils.nameValuePairToJSON(visitorInfo));
                }

            }
            shark = null;
            visitorInfo = null;
            sessionInfo = null;
            data = null;
        }

        function handleCustomVariables(data) {
            //var customVars = data.customVars.customVariable;
            //var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorId);
            //if (customVars && model.get(participantPath)) {
            //    customVars = customVars.constructor === Array ? customVars : [customVars];
            //    model.modify(participantPath + ".participantInfo", {customVariables : customVars}, "name");
            //}
            data = null;
        }

        function handleVisitSessionPages(data) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorId);
            if (model.get(participantPath)) {
                data.pages = data.pages.reverse();
                var currentPages = model.get(participantPath + ".participantInfo.pages");
                var newPageNavigation = currentPages ? data.pages.concat(currentPages) : data.pages;
                model.set(participantPath + ".participantInfo.pages", newPageNavigation);
            }
        }

        function handleChatHistory(data) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorId);
            if (model.get(participantPath)) {
                if (data.chatHistory.chatHistoryRecord) { // reversing the order of the results to make sure presentation will be latest first.
                    data.chatHistory.chatHistoryRecord = data.chatHistory.chatHistoryRecord.reverse(); // move the reversing to the server side.
                }
                model.set(participantPath + ".participantInfo.chatHistory", data.chatHistory);
            }
        }

        function handleOperatorAlerts(data) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorId);
            if (model.get(participantPath) && data.operatorAlerts) {
                model.modify(participantPath + ".participantInfo.operatorAlerts", data.operatorAlerts, "time");
            }
        }

        init();
        return participantController;
    };

    return lpTag.lpParticipantController;

});
